// extracted by mini-css-extract-plugin
export default {"conversationParticipantsContainer":"YjKoMVTldq40-0y4VCoBSw==","addParticipantButton":"nwjdNbHhxwCc3FmQux4AXQ=="};